var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 32,
    viewBox: "0 0 242 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2586_73498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.36 18.5586V13.9756L219.666 7.38257C219.357 7.0251 218.908 6.81958 218.436 6.81958H210.956L220.607 17.9954C220.916 18.3528 221.365 18.5584 221.838 18.5584L225.36 18.5586Z",
    fill: "#DC4405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.956 32H218.435C218.908 32 219.358 31.7941 219.666 31.4358L225.36 24.8295V20.2465H221.838C221.366 20.2465 220.916 20.4522 220.607 20.8103L210.956 32Z",
    fill: "#DC4405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.452 6.81958H233.972C233.5 6.81958 233.05 7.0251 232.742 7.38257L227.048 13.9756V18.5584H230.57C231.043 18.5584 231.492 18.3528 231.801 17.9954L241.452 6.81958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.048 20.2464V24.8292L232.742 31.4355C233.05 31.7938 233.5 31.9998 233.973 31.9998H241.452L231.801 20.8101C231.492 20.452 231.043 20.2462 230.57 20.2462L227.048 20.2464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9285 24.0262C16.9794 25.7986 15.3313 26.8245 12.6773 26.8245C8.79018 26.8245 5.85886 23.6368 5.85886 19.4096V19.3395C5.85886 15.1523 8.78996 11.9949 12.6773 11.9949C14.8266 11.9949 16.7008 12.8256 18.7534 14.6879L18.9853 14.8986L22.8186 10.4787L22.6135 10.2766C19.8899 7.5945 16.836 6.39844 12.712 6.39844C5.23436 6.39844 -0.404541 11.9921 -0.404541 19.4096V19.4799C-0.404541 26.8577 5.14392 32.4209 12.5016 32.4209C16.8368 32.4209 19.82 31.122 22.7981 27.9365L22.9995 27.7213L19.1458 23.8284L18.9285 24.0262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3132 16.5413H31.9593V6.81958H25.9419V32H31.9593V22.138H41.3132V32H47.3306V6.81958H41.3132V16.5413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6151 15.4H56.7035L50.3311 32H56.3504L57.8134 28.1105H67.3733L68.836 32H74.9875L68.6151 15.4ZM59.553 23.4848L62.5932 15.402L65.6332 23.4848H59.553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9667 13.7119L62.6591 -0.114014L57.3516 13.7119H67.9667Z",
    fill: "#DC4405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.725 6.42993C103.4 6.42993 100.715 7.75629 98.5308 10.4812C97.042 7.86409 94.4459 6.42993 91.1674 6.42993C87.6043 6.42993 85.4753 8.23034 84.0191 10.0408V6.81955H77.8035V32H84.0191V17.8955C84.0191 14.3971 85.9526 12.1363 88.945 12.1363C91.8986 12.1363 93.5927 14.1849 93.5927 17.7566V32H99.8085V17.8955C99.8085 14.3433 101.696 12.1363 104.734 12.1363C107.731 12.1363 109.382 14.1487 109.382 17.8027V32H115.598V16.0893C115.598 10.0408 112.281 6.42993 106.725 6.42993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.736 6.81958H120.391V32H126.409V24.6297H130.209C136.429 24.6297 140.448 21.1206 140.448 15.6898V15.6191C140.448 10.2736 136.635 6.81958 130.736 6.81958ZM126.409 12.3108H130.279C132.873 12.3108 134.36 13.5551 134.36 15.7246V15.7948C134.36 17.8368 132.762 19.2086 130.384 19.2086H126.409V12.3108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.701 32H149.719V28.4273V6.81958H143.701V32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.463 6.39844C158.95 6.39844 153.065 12.1136 153.065 19.4096V19.4799C153.065 26.8577 158.795 32.4209 166.392 32.4209C173.905 32.4209 179.79 26.7055 179.79 19.4094V19.3393C179.79 11.9619 174.061 6.39844 166.463 6.39844ZM159.328 19.3395C159.328 15.1523 162.365 11.9949 166.392 11.9949C170.459 11.9949 173.526 15.1825 173.526 19.4096V19.4799C173.526 23.667 170.49 26.8245 166.463 26.8245C162.395 26.8245 159.328 23.6368 159.328 19.4096V19.3395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.769 6.42993C193.798 6.42993 191.391 7.62299 189.435 10.0708V6.81976H183.22V32.0002H189.435V17.8955C189.435 14.3971 191.478 12.1363 194.639 12.1363C197.815 12.1363 199.565 14.1487 199.565 17.8027V32H205.78V16.0893C205.78 10.1313 202.327 6.42993 196.769 6.42993Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2586_73498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 241.452,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCxLogo);
export default __webpack_public_path__ + "static/media/CX-Logo.912a414e2ac3423c7ef47c9e9b7ed1fa.svg";
export { ForwardRef as ReactComponent };